import React from "react";
import axios from "utils/axios";

type Props = {
  id?: number;
  title?: string;
  resourceName?: string;
  websiteLink?: string;
  description?: string;
  file?: any;
};

const Ad: React.FC<Props> = ({
  id = 0,
  title = "AD",
  resourceName = "#",
  websiteLink = "#",
  description = "#",
  file,
}) => {
  const handleClick = async () => {
    window.open(
      websiteLink.includes("https://") ? websiteLink : `https://${websiteLink}`,
      "_blank"
    );
    if (id === 0) return;
    await axios.get(`/api/ad/add_click/${id}`);
  };
  return (
    <div
      className="relative w-80 min-h-[212px] max-h-[212px] py-[20px] px-[20px] border-[1.5px] border-solid border-[#C4C4C4] rounded-sm sm:mx-auto group overflow-hidden cursor-pointer"
      onClick={handleClick}
    >
      {file && (
        <img
          src={file}
          alt="ad logo"
          className="absolute w-[120px] h-20 top-[7px] right-[7px] object-cover"
        />
      )}
      <h5 className="w-40 font-mont font-light text-2xl overflow-hidden text-ellipsis whitespace-nowrap group-hover:underline">
        {title}
      </h5>
      <h6 className="pt-[12px] w-40 font-opensans font-light text-base overflow-hidden text-ellipsis whitespace-nowrap">
        {resourceName}
      </h6>
      <p className="pt-[8px] text-sm limit-line-5">{description}</p>
    </div>
  );
};

export default Ad;
